export const CLEAR_SELECTED_ORDER = 'CLEAR_SELECTED_ORDER'
export const CLEAR_ORDER_SEARCH = 'CLEAR_ORDER_SEARCH'
export const FILTER_ORDERS = 'FILTER_ORDERS'

export const REPLAY_AUTH_REQUESTED = 'REPLAY_AUTH_REQUESTED'
export const REPLAY_AUTH_REQUEST_SUCCEEDED = 'REPLAY_AUTH_REQUEST_SUCCEEDED'
export const REPLAY_AUTH_REQUEST_FAILED = 'REPLAY_AUTH_REQUEST_FAILED'

export const SAVE_ORDER = 'SAVE_ORDER'
export const SAVE_OFFLINE_ORDER = 'SAVE_OFFLINE_ORDER'

export const START_CASH_ORDER = 'START_CASH_ORDER'
export const START_OFFLINE_CARD_ORDER = 'START_OFFLINE_CARD_ORDER'
export const START_ONLINE_CARD_ORDER = 'START_ONLINE_CARD_ORDER'
export const START_NO_OP_TENDER_ORDER = 'START_NO_OP_TENDER_ORDER'

export const SEARCH_ORDER = 'SEARCH_ORDER'
export const SELECT_ORDER = 'SELECT_ORDER'

export const ADD_TO_UNSYNCED_ORDER_LIST = 'ADD_TO_UNSYNCED_ORDER_LIST'

export const SYNC_ORDER_INITIATED = 'SYNC_ORDER_INITIATED'
export const SYNC_ORDER_REQUESTED = 'SYNC_ORDER_REQUESTED'
export const SYNC_ORDER_SUCCEEDED = 'SYNC_ORDER_SUCCEEDED'
export const SYNC_ORDER_FAILED = 'SYNC_ORDER_FAILED'

export const CREATE_OFFLINE_ORDER_SUCCEEDED = 'CREATE_OFFLINE_ORDER_SUCCEEDED'
export const CREATE_OFFLINE_ORDER_FAILED = 'CREATE_OFFLINE_ORDER_FAILED'
export const SYNC_OFFLINE_ORDER_REQUESTED = 'SYNC_OFFLINE_ORDER_REQUESTED'

export const UPDATE_ORDER_SUCCEEDED = 'UPDATE_OFFLINE_ORDER_SUCCEEDED'
export const UPDATE_ORDER_FAILED = 'UPDATE_OFFLINE_ORDER_FAILED'

export const VOID_ORDER_SUCCEEDED = 'VOID_ORDER_SUCCEEDED'
export const VOID_ORDER_FAILED = 'VOID_ORDER_FAILED'

export const ADD_SIGNATURE_TO_ORDER = 'ADD_SIGNATURE_TO_ORDER'
export const ADD_TIP_TO_ORDER = 'ADD_TIP_TO_ORDER'

export const PURGE_ORDERS = 'PURGE_ORDERS'

export const START_CLOSE_TAB_ORDER = 'START_CLOSE_TAB_ORDER'
export const START_CLOSE_TAB_ORDER_WITH_CASH = 'START_CLOSE_TAB_ORDER_WITH_CASH'
export const CLOSE_TAB_ORDER_WITH_CASH = 'CLOSE_TAB_ORDER_WITH_CASH'
export const START_TAB_ORDER_ADJUSTMENT = 'START_TAB_ORDER_ADJUSTMENT'
export const START_TAB_ORDER_ADJUSTMENT_AND_CLOSE = 'START_TAB_ORDER_ADJUSTMENT_AND_CLOSE'
export const START_TAB_WITH_REMOTE_PAYMENT = 'START_TAB_WITH_REMOTE_PAYMENT'
export const CLOSE_TAB_NO_OP_TENDER = 'CLOSE_TAB_NO_OP_TENDER'

export const MUTATION_REQUESTED = 'MUTATION_REQUESTED'
export const MUTATION_SUCCEEDED = 'MUTATION_SUCCEEDED'
export const MUTATION_FAILED = 'MUTATION_FAILED'

export const CLOSE_TAB_ORDER_REQUESTED = 'CLOSE_TAB_ORDER_REQUESTED'
export const CLOSE_TAB_ORDER_SUCCEEDED = 'CLOSE_TAB_ORDER_SUCCEEDED'
export const CLOSE_TAB_ORDER_FAILED = 'CLOSE_TAB_ORDER_FAILED'

export const PRE_ORDERS_REQUESTED = 'PRE_ORDERS_REQUESTED'
export const LOAD_PRE_ORDERS_SUCCEEDED = 'LOAD_PRE_ORDERS_SUCCEEDED'
export const LOAD_PRE_ORDERS_FAILED = 'LOAD_PRE_ORDERS_FAILED'

export const SEND_ORDER_EMAIL = 'SEND_ORDER_EMAIL'

export const UPDATE_ORDER_EXEMPTION_OVERRIDES = 'UPDATE_ORDER_EXEMPTION_OVERRIDES'
export const APPLY_ORDER_EXEMPTIONS = 'APPLY_ORDER_EXEMPTIONS'

export const ORDER_DETAILS_REQUESTED = 'ORDER_DETAILS_REQUESTED'
export const LOAD_ORDER_DETAILS_SUCCEEDED = 'LOAD_ORDER_DETAILS_SUCCEEDED'
export const LOAD_ORDER_DETAILS_FAILED = 'LOAD_ORDER_DETAILS_FAILED'

export const ORDERS_DELTAS_REQUESTED = 'ORDERS_DELTAS_REQUESTED'
export const LOAD_ORDERS_DELTAS_SUCCEEDED = 'LOAD_ORDERS_DELTAS_SUCCEEDED'
export const LOAD_ORDERS_DELTAS_FAILED = 'LOAD_ORDERS_DELTAS_FAILED'

export const REOPEN_ORDER_REQUESTED = 'REOPEN_ORDER_REQUESTED'
export const REOPEN_ORDER_FAILED = 'REOPEN_ORDER_FAILED'

export const UPDATE_ORDER_LINE_ITEMS_REQUESTED = 'UPDATE_ORDER_LINE_ITEMS_REQUESTED'
export const UPDATE_ORDER_LINE_ITEMS_SUCCEEDED = 'UPDATE_ORDER_LINE_ITEMS_SUCCEEDED'
export const UPDATE_ORDER_LINE_ITEMS_FAILED = 'UPDATE_ORDER_LINE_ITEMS_FAILED'

export const SPLIT_ORDER_REQUESTED = 'SPLIT_ORDER_REQUESTED'
export const SPLIT_ORDER_SUCCEEDED = 'SPLIT_ORDER_SUCCEEDED'
export const SPLIT_ORDER_FAILED = 'SPLIT_ORDER_FAILED'

export const UPDATE_PAYMENT_ON_ORDER = 'UPDATE_PAYMENT_ON_ORDER'
export const ADD_PAYMENT_ON_ORDER = 'ADD_PAYMENT_ON_ORDER'
export const ADD_TENDER_ON_ORDER = 'ADD_TENDER_ON_ORDER'

export const purgeOrders = (orderIds) => ({
  type: PURGE_ORDERS,
  payload: { orderIds },
})

export const clearOrderSearch = () => ({
  type: CLEAR_ORDER_SEARCH,
})

export const clearSelectedOrder = () => ({
  type: CLEAR_SELECTED_ORDER,
})

export const filterOrders = (filter) => ({
  type: FILTER_ORDERS,
  payload: filter,
})

export const replayAuthRequested = (orderId) => ({
  type: REPLAY_AUTH_REQUESTED,
  orderId,
})

export const replayAuthRequestSucceeded = (payload) => ({
  type: REPLAY_AUTH_REQUEST_SUCCEEDED,
  payload,
})

export const replayAuthRequestFailed = (payload) => ({
  type: REPLAY_AUTH_REQUEST_FAILED,
  payload,
})

export const saveOrder = (payload) => ({
  type: SAVE_ORDER,
  payload,
})

export const saveOfflineOrder = (payload) => ({
  type: SAVE_OFFLINE_ORDER,
  payload,
})

export const searchOrders = (search) => ({
  type: SEARCH_ORDER,
  payload: search,
})

export const selectOrder = (id) => ({
  type: SELECT_ORDER,
  payload: id,
})

export const startOfflineCardOrder = (payload) => ({
  type: START_OFFLINE_CARD_ORDER,
  payload,
})

export const startOnlineCardOrder = (payload) => ({
  type: START_ONLINE_CARD_ORDER,
  payload,
})

export const startCashOrder = (payload) => ({
  type: START_CASH_ORDER,
  payload,
})

export const startNoOpTenderOrder = (payload) => ({
  type: START_NO_OP_TENDER_ORDER,
  payload,
})

export const closeTabNoOpTender = (payload) => ({
  type: CLOSE_TAB_NO_OP_TENDER,
  payload,
})

export const addToUnsyncedOrderList = (id) => ({
  type: ADD_TO_UNSYNCED_ORDER_LIST,
  payload: id,
})

export const syncOrderInitiated = (id) => ({
  type: SYNC_ORDER_INITIATED,
  id,
})

export const syncOrderRequested = (id) => ({
  type: SYNC_ORDER_REQUESTED,
  id,
})

export const syncOrderSucceeded = (payload, order) => ({
  type: SYNC_ORDER_SUCCEEDED,
  payload,
  order,
})

export const syncOrderFailed = (payload, order) => ({
  type: SYNC_ORDER_FAILED,
  payload,
  order,
})

export const syncOfflineOrderRequested = (id) => ({
  type: SYNC_OFFLINE_ORDER_REQUESTED,
  id,
})

export const createOfflineOrderSucceeded = (payload, uuid) => ({
  type: CREATE_OFFLINE_ORDER_SUCCEEDED,
  payload,
  uuid,
})

export const createOfflineOrderFailed = (payload, uuid) => ({
  type: CREATE_OFFLINE_ORDER_FAILED,
  payload,
  uuid,
})

export const updateOrderSucceeded = (payload, uuid) => ({
  type: UPDATE_ORDER_SUCCEEDED,
  payload,
  uuid,
})

export const updateOrderFailed = (payload, uuid) => ({
  type: UPDATE_ORDER_FAILED,
  payload,
  uuid,
})

export const voidOrderSucceeded = (orderId, freedomPayResponse) => ({
  type: VOID_ORDER_SUCCEEDED,
  orderId,
  freedomPayResponse,
})

export const voidOrderFailed = (orderId, freedomPayResponse) => ({
  type: VOID_ORDER_FAILED,
  orderId,
  freedomPayResponse,
})

export const addSignatureToOrder = (orderUuid, signature) => ({
  type: ADD_SIGNATURE_TO_ORDER,
  payload: { orderUuid, signature }
})

export const addTipToOrder = (orderUuid, tipAmountInCents) => ({
  type: ADD_TIP_TO_ORDER,
  payload: { orderUuid, tipAmountInCents }
})

export const startCloseTabOrderWithCash = (orderId) => ({
  type: START_CLOSE_TAB_ORDER_WITH_CASH,
  payload: { orderId },
})

export const closeTabOrderWithCash = (orderId) => ({
  type: CLOSE_TAB_ORDER_WITH_CASH,
  payload: { orderId },
})

export const startCloseTabOrder = ({
  cardReaderData = {},
  deferClose = false,
  newCard = false,
  orderId,
  paymentPreference,
  remotePayment = false,
  updateExemptions,
}) => ({
  type: START_CLOSE_TAB_ORDER,
  payload: { cardReaderData, deferClose, newCard, orderId, paymentPreference, remotePayment, updateExemptions },
})

export const mutationRequested = (payload) => ({
  type: MUTATION_REQUESTED,
  payload,
})

export const mutationSucceeded = (payload) => ({
  type: MUTATION_SUCCEEDED,
  payload,
})

export const mutationFailed = (payload) => ({
  type: MUTATION_FAILED,
  payload,
})

export const closeTabOrderSucceeded = (orderId, result) => ({
  type: CLOSE_TAB_ORDER_SUCCEEDED,
  payload: {
    orderId,
    ...result,
  },
})

export const closeTabOrderFailed = (orderId, result) => ({
  type: CLOSE_TAB_ORDER_FAILED,
  payload: {
    orderId,
    ...result,
  },
})

export const startTabOrderAdjustment = (orderId, adjustmentType, args={}) => ({
  type: START_TAB_ORDER_ADJUSTMENT,
  payload: {
    orderId,
    adjustmentType,
    ...args,
  }
})

export const startTabOrderAdjustmentAndClose = ({
  adjustmentType = 'add',
  cardReaderData = {},
  deferClose = false,
  newCard = false,
  paymentPreference = {},
  orderId,
}) => ({
  type: START_TAB_ORDER_ADJUSTMENT_AND_CLOSE,
  payload: { adjustmentType, cardReaderData, deferClose, newCard, orderId, paymentPreference },
})

export const preOrdersRequested = (salesEventId, standUuids) => ({
  type: PRE_ORDERS_REQUESTED,
  payload: { salesEventId, standUuids }
})

preOrdersRequested.type = PRE_ORDERS_REQUESTED

export const loadPreOrdersSucceeded = (payload) => ({
  type: LOAD_PRE_ORDERS_SUCCEEDED,
  payload
})

export const loadPreOrdersFailed = (payload) => ({
  type: LOAD_PRE_ORDERS_FAILED,
  payload
})

export const startTabWithRemotePayment = (payload) => ({
  type: START_TAB_WITH_REMOTE_PAYMENT,
  payload
})

export const sendOrderEmail = (payload) => ({
  type: SEND_ORDER_EMAIL,
  payload,
})

export const updateOrderExemptionOverrides = (orderId, exemptionOverrides) => ({
  type: UPDATE_ORDER_EXEMPTION_OVERRIDES,
  payload: { orderId, exemptionOverrides }
})

updateOrderExemptionOverrides.type = UPDATE_ORDER_EXEMPTION_OVERRIDES

export const applyOrderExemptions = (orderId, exemptionOverrides) => ({
  type: APPLY_ORDER_EXEMPTIONS,
  payload: { orderId, exemptionOverrides }
})

applyOrderExemptions.type = APPLY_ORDER_EXEMPTIONS

export const orderDetailsRequested = (orderUuid) => ({
  type: ORDER_DETAILS_REQUESTED,
  payload: { orderUuid }
})

orderDetailsRequested.type = ORDER_DETAILS_REQUESTED

export const loadOrderDetailsSucceeded = (payload) => ({
  type: LOAD_ORDER_DETAILS_SUCCEEDED,
  payload
})

export const loadOrderDetailsFailed = (payload) => ({
  type: LOAD_ORDER_DETAILS_FAILED,
  payload
})

export const ordersDeltasRequested = (payload) => ({
  type: ORDERS_DELTAS_REQUESTED,
  payload
})

ordersDeltasRequested.type = ORDERS_DELTAS_REQUESTED

export const loadOrdersDeltasSucceeded = (payload) => ({
  type: LOAD_ORDERS_DELTAS_SUCCEEDED,
  payload
})

export const loadOrdersDeltasFailed = (payload) => ({
  type: LOAD_ORDERS_DELTAS_FAILED,
  payload
})

export const reopenOrder = (payload) => ({
  type: REOPEN_ORDER_REQUESTED,
  payload
})

reopenOrder.type = REOPEN_ORDER_REQUESTED

export const reopenOrderFailed = () => ({
  type: REOPEN_ORDER_FAILED,
})

export const updateOrderLineItemsRequested = (payload) => ({
  type: UPDATE_ORDER_LINE_ITEMS_REQUESTED,
  payload
})

updateOrderLineItemsRequested.type = UPDATE_ORDER_LINE_ITEMS_REQUESTED

export const updateOrderLineItemsSucceeded = (payload) => ({
  type: UPDATE_ORDER_LINE_ITEMS_SUCCEEDED,
  payload
})

export const updateOrderLineItemsFailed = () => ({
  type: UPDATE_ORDER_LINE_ITEMS_FAILED,
})

export const splitOrder = (payload) => ({
  type: SPLIT_ORDER_REQUESTED,
  payload,
})

splitOrder.type = SPLIT_ORDER_REQUESTED

export const splitOrderSucceeded = (payload) => ({
  type: SPLIT_ORDER_SUCCEEDED,
  payload,
})

splitOrderSucceeded.type = SPLIT_ORDER_SUCCEEDED

export const splitOrderFailed = (payload) => ({
  type: SPLIT_ORDER_FAILED,
  payload,
})

splitOrderFailed.type = SPLIT_ORDER_FAILED

export const updatePaymentOnOrder = (payload) => ({
  type: UPDATE_PAYMENT_ON_ORDER,
  payload,
})

updatePaymentOnOrder.type = UPDATE_PAYMENT_ON_ORDER

export const addPaymentOnOrder = (payload) => ({
  type: ADD_PAYMENT_ON_ORDER,
  payload,
})

addPaymentOnOrder.type = ADD_PAYMENT_ON_ORDER

export const addTenderOnOrder = (payload) => ({
  type: ADD_TENDER_ON_ORDER,
  payload,
})

addTenderOnOrder.type = ADD_TENDER_ON_ORDER
